"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyTermsInputSchema = exports.CouponRegionStatusResponseSchema = exports.CouponRegionStatusSchema = exports.CouponStatusResponseSchema = exports.CouponRegionStatusInputSchema = exports.CouponStatusInputSchema = exports.DownloadCouponResponseSchema = exports.DownloadCouponInputSchema = exports.CouponTypeSchema = exports.RegionKrCode = exports.MillionCouponType = void 0;
var zod_1 = require("zod");
var member_1 = require("../member");
var string_to_json_1 = require("../utils/string-to-json");
var RegionCode = {
    GANGWON: 'GANGWON',
    GYEONGNAM: 'GYEONGNAM',
    GYEONGBUK: 'GYEONGBUK',
    GWANGJU: 'GWANGJU',
    DAEGU: 'DAEGU',
    DAEJEON: 'DAEJEON',
    BUSAN: 'BUSAN',
    ULSAN: 'ULSAN',
    JEONNAM: 'JEONNAM',
    JEONBUK: 'JEONBUK',
    JEJU: 'JEJU',
    CHUNGNAM: 'CHUNGNAM',
    CHUNGBUK: 'CHUNGBUK',
};
exports.MillionCouponType = __assign({ 
    // 재난지역 특별편 쿠폰
    SEVENTY_THOUSAND: 'SEVENTY_THOUSAND', EIGHTY_THOUSAND: 'EIGHTY_THOUSAND', 
    // 전국편 쿠폰
    THIRTY_THOUSAND: 'THIRTY_THOUSAND', TWENTY_THOUSAND: 'TWENTY_THOUSAND' }, RegionCode);
exports.RegionKrCode = {
    GANGWON: '강원',
    GYEONGNAM: '경남',
    GYEONGBUK: '경북',
    GWANGJU: '광주',
    DAEGU: '대구',
    DAEJEON: '대전',
    BUSAN: '부산',
    ULSAN: '울산',
    JEONNAM: '전남',
    JEONBUK: '전북',
    JEJU: '제주',
    CHUNGNAM: '충남',
    CHUNGBUK: '충북',
};
exports.CouponTypeSchema = zod_1.z.nativeEnum(exports.MillionCouponType);
exports.DownloadCouponInputSchema = zod_1.z.object({
    coupon: exports.CouponTypeSchema,
});
exports.DownloadCouponResponseSchema = zod_1.z.object({
    couponType: exports.CouponTypeSchema,
});
exports.CouponStatusInputSchema = zod_1.z.object({
    promotionType: zod_1.z.nativeEnum(member_1.PromotionKey),
    agreementType: member_1.AgreementsKeySchema,
});
exports.CouponRegionStatusInputSchema = zod_1.z.object({
    promotionType: zod_1.z.nativeEnum(member_1.PromotionKey),
    agreementType: member_1.AgreementsKeySchema,
});
exports.CouponStatusResponseSchema = zod_1.z.object({
    isLogin: zod_1.z.boolean(),
    authenticationStatus: zod_1.z.object({
        authenticated: zod_1.z.boolean(),
        agreements: zod_1.z
            .object({
            isCertificationAgreed: zod_1.z.boolean().nullable(),
        })
            .nullish(),
        errorCode: zod_1.z.nativeEnum(member_1.AuthenticationErrorCode).nullish(),
    }),
    regionData: member_1.PromotionDataSchema.pick({ data: true }),
    availableTime: zod_1.z.boolean(),
    couponStatus: zod_1.z.object({
        downloadedCoupon: zod_1.z.object({
            couponType: zod_1.z.nativeEnum(exports.MillionCouponType).nullable(),
            redeemed: zod_1.z.boolean(),
        }),
        availableCoupons: exports.CouponTypeSchema.array().nullable(),
    }),
});
var CouponStatusRegionCouponsSchema = zod_1.z.nativeEnum(RegionCode);
exports.CouponRegionStatusSchema = zod_1.z.object({
    availableTime: zod_1.z.boolean(),
    notAvailableStartTime: zod_1.z.string(),
    notAvailableEndTime: zod_1.z.string(),
    noticeMessage: zod_1.z.string().nullish(),
    coupons: CouponStatusRegionCouponsSchema.array(),
});
// 숙박대전 지역편 응답 스키마
exports.CouponRegionStatusResponseSchema = zod_1.z.object({
    isLogin: zod_1.z.boolean(),
    authenticationStatus: zod_1.z.object({
        authenticated: zod_1.z.boolean(),
        agreements: zod_1.z
            .object({
            isCertificationAgreed: zod_1.z.boolean().nullable(),
        })
            .nullish(),
        errorCode: zod_1.z.nativeEnum(member_1.AuthenticationErrorCode).nullish(),
    }),
    regionData: member_1.PromotionDataSchema.pick({ data: true }),
    availableTime: zod_1.z.boolean(),
    couponStatus: zod_1.z.object({
        downloadedCoupon: zod_1.z
            .object({
            couponType: zod_1.z.nativeEnum(exports.MillionCouponType),
            redeemed: zod_1.z.boolean(),
        })
            .nullable(),
        availableCoupons: CouponStatusRegionCouponsSchema.array().nullable(),
    }),
});
var PolicyTermsSchema = zod_1.z.object({
    agreePrivacyRequired: zod_1.z.string(),
    agree3rdRequired: zod_1.z.string(),
    agreeCertificationRequired: zod_1.z.string(),
});
exports.PolicyTermsInputSchema = zod_1.z.object({
    terms: string_to_json_1.stringToJSONSchema.pipe(PolicyTermsSchema),
});
